"use strict";
/*
 * Created on 2019-03-21
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var utils_1 = require("../../../core/utils");

var SelloutReleasePart_1 = require("../../model/sellout/SelloutReleasePart");

var SelloutReleasePartConverter_1 = require("./SelloutReleasePartConverter");
/**
 * @author JMr
 */


var SelloutReleasePartConverterImpl =
/*#__PURE__*/
function (_SelloutReleasePartCo) {
  _inherits(SelloutReleasePartConverterImpl, _SelloutReleasePartCo);

  function SelloutReleasePartConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, SelloutReleasePartConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleasePartConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleasePartConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleasePart_1.SelloutReleasePart(SelloutReleasePart_1.SelloutReleasePart.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), SelloutReleasePart_1.SelloutReleasePart.schema.productCategoryId.valueOf(conversions.toClassReferenceId(source.productCategoryId)), SelloutReleasePart_1.SelloutReleasePart.schema.approved.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.firstApproval.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.approvedByUserId.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.approvedByUserName.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.cmDeadlineMissed.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.workflowCaseId.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.calcWorkflowCaseId.valueOfField(source), SelloutReleasePart_1.SelloutReleasePart.schema.calcProgressMonitorId.valueOf(conversions.toClassReferenceId(source.calcProgressMonitorId)), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), SelloutReleasePart_1.SelloutReleasePart.schema.readonly.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId),
        approved: utils_1.Utils.isMoment(source.approved) ? conversions.fromDate(source.approved) : null,
        firstApproval: utils_1.Utils.isMoment(source.firstApproval) ? conversions.fromDate(source.firstApproval) : null,
        approvedByUserId: source.approvedByUserId,
        approvedByUserName: source.approvedByUserName,
        cmDeadlineMissed: source.cmDeadlineMissed,
        workflowCaseId: source.workflowCaseId,
        calcWorkflowCaseId: source.calcWorkflowCaseId,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions),
        calcProgressMonitorId: conversions.toDocumentReferenceId(source.calcProgressMonitorId),
        readonly: source.readonly
      });
      return result;
    }
  }]);

  return SelloutReleasePartConverterImpl;
}(SelloutReleasePartConverter_1.SelloutReleasePartConverter);

SelloutReleasePartConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], SelloutReleasePartConverterImpl);
exports.SelloutReleasePartConverterImpl = SelloutReleasePartConverterImpl;